// ═══════════════════════════════════════════════════════════════════════════════
// Client-side feature flags
//
// Each flag is read from import.meta.env at build time. The Static Web App
// build receives VITE_* env vars as part of the workflow. To flip a flag,
// set the env var and rebuild.
// ═══════════════════════════════════════════════════════════════════════════════

const truthy = (v: unknown) => {
  if (typeof v !== 'string') return false;
  const s = v.toLowerCase();
  return s === '1' || s === 'true' || s === 'on' || s === 'yes';
};

/** Hub-Native Analyst Engineering Request flow. When off, the FAB hides,
 *  the contextual buttons hide, the My Engineering Requests sidebar entry
 *  hides, and the backend returns 404 on the analyst endpoints. */
export const FEATURE_ANALYST_ENGINEERING_FAB = truthy(
  (import.meta as { env?: Record<string, unknown> }).env?.VITE_FEATURE_ANALYST_ENGINEERING_FAB,
);
